import React from 'react'
import AdFrame from '@chegg-wt/core/components/AdFrame'
import Footer from '@chegg-wt/core/components/Footer'
import Nav from '@chegg-wt/core/components/Nav'
import CheggLayout from '@chegg-wt/core/components/CheggLayout'
import GlobalModal from '@chegg-wt/core/components/Modals/GlobalModal'
import { Advert } from '@chegg-wt/core/components/Advert'
import { FullWidthBanner } from '@chegg-wt/core/components/FullWidthBanner'
import usePriceTest from '@chegg-wt/core/hooks/usePriceTest'
import {
  DISCOUNT_BANNER_SUBTITLE,
  discountBannerTitle,
} from '@chegg-wt/core/constants/discountBannerText'
import { useSelector } from 'react-redux'
import { isWritingAssistantHomeEnabledSelector } from '@chegg-wt/core-wa/state/selectors'
import { Config } from '@chegg-wt/core/config'
import {
  CM_PRODUCT_NAME,
  CTFM_PRODUCT_NAME,
  EB_PRODUCT_NAME,
} from '@chegg-wt/core/constants/site'
import HomePageFooter from '../HomePageFooter'
import * as Styled from './styled'

// these variables are for CTFM new layout experiment remove them once experiment is over
export const SVP_VARIANT_ONE = '1'
export const SVP_VARIANT_TWO = '2'

const AdFrameMaybe = ({ routeName, isPro, children, useAdframeLayout, showSvp }) =>
  useAdframeLayout ? (
    <AdFrame showSvp={showSvp} routeName={routeName} isPro={isPro}>
      {children}
    </AdFrame>
  ) : (
    <>{children}</>
  )

const TopAdMaybe = ({ isPro, useAdframeLayout, showSvp, variant }) => {
  if (showSvp) {
    return (
      <Styled.SvpTopWrapper variant={variant}>
        <Advert placement="T1" className="adds" hideAds={isPro} />
        <Styled.SvpHideWrapperT2 variant={variant}>
          <Advert placement="T2" className="adds svp-t2" hideAds={isPro} />
        </Styled.SvpHideWrapperT2>
      </Styled.SvpTopWrapper>
    )
  }
  return useAdframeLayout ? (
    <Advert placement="T1" className="adds top" hideAds={isPro} />
  ) : null
}

const AppLayout = ({
  isCheggFree,
  exportTabIds,
  children,
  hideLayout,
  hideAdRail,
  useAdframeLayout,
  routeName,
  isPro,
  errorPageMaybe,
  navItemsSelector,
  NotificationBanner,
  footerContents,
  showSvp,
  svpVariant,
  showBanner,
  bannerText,
  isHomePage,
  fullWidthBannerProps,
}) => {
  const { discountPercentage } = usePriceTest()
  const isWritingAssistantHomeEnabled = useSelector(isWritingAssistantHomeEnabledSelector)

  const isEbOrCmHome =
    isHomePage && [CM_PRODUCT_NAME, EB_PRODUCT_NAME].includes(Config.siteName)

  /* TODO refactor this to show/hide layouts */
  if (isCheggFree) {
    return (
      <>
        <GlobalModal exportTabIds={exportTabIds} />
        <CheggLayout isCheggFree={isCheggFree}>{errorPageMaybe || children}</CheggLayout>
      </>
    )
  }

  if (hideAdRail || hideLayout) {
    return (
      <>
        <GlobalModal exportTabIds={exportTabIds} />
        {errorPageMaybe || children}
      </>
    )
  }

  const getNavHeader = () => {
    if (routeName === 'toWritingAssistant') return null

    return <Nav navItemsSelector={navItemsSelector} isHome={isHomePage} />
  }

  const getFooter = () => {
    if (routeName === 'toWritingAssistant' && Config.siteName === CM_PRODUCT_NAME) {
      return <HomePageFooter />
    }
    if (!isEbOrCmHome) return <Footer {...footerContents} />

    if (isWritingAssistantHomeEnabled !== null) {
      if (isWritingAssistantHomeEnabled) return <HomePageFooter />
      return <Footer {...footerContents} />
    }

    return null
  }

  const showCtfmHomePageBanner =
    isHomePage && showBanner && Config.siteName === CTFM_PRODUCT_NAME

  return (
    <AdFrameMaybe
      showSvp={showSvp}
      routeName={routeName}
      isPro={isPro}
      useAdframeLayout={useAdframeLayout}
    >
      <GlobalModal exportTabIds={exportTabIds} />
      {getNavHeader()}
      {showCtfmHomePageBanner && (
        <Styled.WelcomeBanner>{bannerText}</Styled.WelcomeBanner>
      )}
      {!isPro && showBanner && discountPercentage > 0 && (
        <FullWidthBanner
          title={discountBannerTitle(discountPercentage)}
          subtitle={DISCOUNT_BANNER_SUBTITLE}
          backgroundColour={fullWidthBannerProps.backgroundColour}
          minHeight={fullWidthBannerProps.minHeight}
          data-test="discount-banner"
        />
      )}
      {NotificationBanner && <NotificationBanner />}
      <TopAdMaybe
        showSvp={showSvp}
        useAdframeLayout={useAdframeLayout}
        isPro={isPro}
        variant={svpVariant}
      />
      {errorPageMaybe || children}
      {getFooter()}
    </AdFrameMaybe>
  )
}

export default AppLayout
